var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarExplodingMini(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "StarExplodingMini") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.847 8.874l.97 3.12c.2.65-.04 1.34-.59 1.73-.26.18-.56.27-.86.27-.32 0-.64-.1-.91-.31l-2.48-1.88-2.48 1.88a1.5 1.5 0 01-1.77.03c-.56-.38-.79-1.08-.59-1.73l.97-3.12-2.52-1.92c-.53-.4-.74-1.09-.53-1.73.22-.63.78-1.04 1.44-1.04h3.07l.96-3.09c.2-.65.78-1.08 1.45-1.08.67 0 1.25.43 1.45 1.08l.96 3.09h3.07c.66 0 1.23.41 1.44 1.04.21.64 0 1.34-.53 1.74l-2.52 1.92zm-2.12-.08l.01.01c-.12-.4.02-.84.35-1.09l2.01-1.53h-2.44c-.43 0-.82-.28-.95-.7l-.72-2.31-.72 2.31c-.13.41-.52.7-.96.7h-2.44l2.01 1.53c.33.25.47.69.35 1.09l-.75 2.4 1.89-1.44c.36-.27.85-.27 1.21 0l1.89 1.43-.74-2.4zm-8.2-.18l.01-.01c.49-.24 1.09-.04 1.34.45.24.49.04 1.09-.45 1.34l-1 .5a1.007 1.007 0 01-1.35-.44 1.01 1.01 0 01.45-1.34l1-.5zm13.9.5l.01.01c.5.25.7.85.45 1.34a1.007 1.007 0 01-1.35.44l-1-.5c-.5-.25-.7-.85-.45-1.34.25-.5.85-.69 1.34-.45l1 .5zm-12.16-6.4l.01-.01-1-1a.996.996 0 111.41-1.41l1 1.01c.39.39.39 1.02 0 1.41-.2.19-.45.29-.71.29-.26 0-.51-.09-.71-.29zm8.72.29h-.01a.996.996 0 01-.7-1.7l1-1a.996.996 0 111.41 1.41l-1 1a1.022 1.022 0 01-.7.29zm-4.01 10c.55 0 1 .45 1 1v1c0 .55-.45 1-1 1s-1-.45-1-1v-1c0-.55.45-1 1-1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarExplodingMini);
export default __webpack_public_path__ + "static/media/StarExplodingMini.520feb74591b9756f8f6978a04c163ba.svg";
export { ForwardRef as ReactComponent };